import { ActivityProgress } from './activity-progress';
import { IframeActivityPayloadDto } from './iframe-activity-payload-dto';

export const DEFAULT_IFRAME_ACTIVITY_MODAL_HEIGHT = 600;

export const isFiniteNumber = (value: {}): value is number => typeof value === 'number' && isFinite(value);

export const isActivityProgress = (payload: IframeActivityPayloadDto): payload is ActivityProgress =>
  !!payload && isFiniteNumber(payload.timeOnTask) && payload.timeOnTask >= 0 && typeof payload.completed === 'boolean';

export const toHeight = (payload: IframeActivityPayloadDto): number =>
  payload && isFiniteNumber(payload.height) && payload.height > 0
    ? payload.height
    : DEFAULT_IFRAME_ACTIVITY_MODAL_HEIGHT;

export const toOrigin = (url: string): string => {
  try {
    return new URL(url).origin;
  } catch {
    return null;
  }
};



// WEBPACK FOOTER //
// ./ts/app/shared/iframe-activity-modal/iframe-activity-modal.helpers.ts